type Props = {};

const BreakDownIndex = (props: Props) => {
  return (
    <div>Break Down Index</div>
  );
};

export default BreakDownIndex;